import React, { useEffect, useState } from "react";
import classes from "./specialeventsdetail.module.scss";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Switch from "@mui/material/Switch";
import { TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import { Table } from "@genesis/ui-kit";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button,Box } from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import {isEmpty, splitTimeFromDateTime, alertGeneraliseMessage} from "../../Shared/Utill/Utills";
import Cookie from "js-cookie";
import axios from "axios";
import SpecialEventsDetailPopup from "./specialEventsDetailPopup";
import { useSelector } from "react-redux";
import SnackBar from "../../Shared/Snackbar/Snackbar";
import UnavailableEventPopup from "./unavailableEventPopup";
import { center, object } from "underscore";
import { IsTokenValid } from "../../Shared/Utill/AuthUtil";
import TimeOffPTOLinkComp, { ComponentType } from "../../Components/AvailabilitySelections/TimeOffPTOLinkComp";
import NotificationView from "../../Shared/Notification/NotificationView";
import { WarningIcon } from "../../Resources/availabilityicon/IconUtils";
import TimeOffPTOLinkComp2 from "./TimeOffPTOLinkComp2";
import { messages } from "../../Shared/Messages/ErrorMessages";
import { toUpperCaseString } from "../../Shared/Utill/Utills";

const SpecialEventsDetail = () => {
  const location = useLocation();
  const history = useNavigate();
  console.log(location.state.eId);
  const personDetails = useSelector((state) => state.person.personData);
  const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);
  const urlDetails = useSelector((state) => state.url.urlData);

  const [checked, setChecked] = React.useState(false);
  const [showPopup,setShowPopup] = React.useState(false);
  const [popupdata, setPopupData] = React.useState({});
  const [isAlertOpen, setAlertOpen] = React.useState({});

  const eventId = location.state.eId;
  const evenName = location.state.eName;
  const colleagueTKN = Cookie.get('X_TKN');

  const [sEventList, setSEventList] = useState([]);

  const { message, severity, open } = isAlertOpen || {};
  const [unavailableDialog, setunavailableDialog] = useState(false);
  const ptoQuickRefLink =urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_SEA_QRC;
  const ptoLink = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_PTO_URL;
  const [iOrD, setiOrD] = React.useState("i");
  const [unavialableDialogText, setUnavialableDialogText] = React.useState({title : '', message : ''});
  const [isMobile , setMobile] = useState(window.innerWidth >= 375 && window.innerWidth<=767);
  const [isTablet, setTablet] = useState(window.innerWidth >= 768 && window.innerWidth<1300);
  const [accomCrossover, setAccomCrossover] = React.useState(false);
  const [showUnavailable,setShowUnavailable] = React.useState(false);
  const customQuery ='@media (max-width: 768px)';
  const languageDetails = useSelector((state) => state.selectedLanguage.selectedLanguageData);
  const [state, setState] = React.useState(new Date());

  const handle_time = () => {
    setState(new Date());
  };

const updateMedia = () => {
   setTablet(window.innerWidth >= 768 && window.innerWidth <= 1300);
   setMobile(window.innerWidth >= 375 && window.innerWidth <= 767);
};

useEffect(() => {
  window.addEventListener("resize", updateMedia);
  return () => window.removeEventListener("resize", updateMedia);
});

  const handleChange = (event) => {
    if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
      setAlertOpen({
        open: true,
        severity: 'error',
        message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
      })
      return;
    }
    //set initial value of setChecked by iterating even list 
    setChecked(event.target.checked);
    if (event.target.checked === true) {
      setiOrD("i");
      setUnavialableDialogText({title : "Unavailable For This Event",
      message :'By selecting "Unavailable," you will lose all previous selections for this event. Are you sure you want to save changes?'});
      setunavailableDialog(true);
     } else {
      setiOrD("d");
      setUnavialableDialogText({title: 'Reset Your Availability For This Event',
                                message: 'By switching off "Unavailable," you will be able to make selections for this event. Are you sure, you are available and want to save selections as per your availability?' });
      setunavailableDialog(true);
      // show alert
      // setAlertOpen({
      //   open: true,
      //   severity: 'info',
      //   message : "You have selected to be available for this event. Please select each day to update your availability.",
      // })
      // 
    }
  };

  const selectAvailability = (eventDay) => {
    console.log("Clicked Event -----" + JSON.stringify(eventDay));
    setPopupData(eventDay);
    setShowPopup(true);
  }

  const handleCellClick = (eventDay) => {
    console.log(eventDay);
    setPopupData(eventDay);
    setShowPopup(true); 
  }

  const popupClose = () => {
    setShowPopup(false);
  }

  const onUpdateAvailabilitySuccess = (severity) => {
    setShowPopup(false);
    // refresh the event detail APi now
    getEventDetailByEvId(eventId);
    // show alert notification
    setAlertOpen({
      open: true,
      severity: severity,
      message : evenName + " selections saved successfully",
    })
;  }

  useEffect(() => {
    getEventDetailByEvId(eventId);
  }, []);

  useEffect(() => {
    getEventDetailsByEvtIdAssoc_SP(eventId);
  }, []);

  useEffect(() => {
    handle_time()
  }, [languageDetails.selected]);


  const getEventDetailsByEvtIdAssoc_SP = (eventId) => {
    let dataMock = {
      divNbr: 71,
      locNbr: 0,
      eventId: 592,
      ascNbr: "72640097"
  }
  let reqPayload = {
    // divNbr: personDetails.mydiv,
    // locNbr: personDetails.mystore,
    divNbr: personODSFuture.mydiv,
    locNbr: personODSFuture.mystore,
    eventId: eventId,
    ascNbr: personDetails.emplID,
  }
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_EVENT_DETAILS_BY_EVT_ID_ASSOC}`,
      method: "POST",
      data: reqPayload ,
      headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + colleagueTKN,
      },
      
    })
      .then((res) => {
        
        setShowUnavailable(res.data[0].unavailableActive === "y" ? true:false)
        console.log(JSON.stringify(res.data[0].unavailableActive) + " HUGEEE")
        //setSEventList(res.data);
        // check whether unavailable for entire even
        //setChecked(checkListForUnavailableAll(res.data));
      })
      .catch((err) => {
        console.log(err);
        if(err.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_EVENT_DETAILS_BY_EVT_ID_ASSOC}...failed`})
        }

      });
  };

  
  // api call and recieve event detail
  const getEventDetailByEvId = (eventId) => {
    let dataMock = {
      divNbr: 71,
      locNbr: 0,
      eventId: 592,
      ascNbr: "72640097"
  }
  let reqPayload = {
    // divNbr: personDetails.mydiv,
    // locNbr: personDetails.mystore,
    divNbr: personODSFuture.mydiv,
    locNbr: personODSFuture.mystore,
    eventId: eventId,
    ascNbr: personDetails.emplID,
  }
    axios({
      url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_EVENT_DETAIL_BY_EVENTID}`,
      method: "POST",
      data: reqPayload ,
      headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + colleagueTKN,
      },
      
    })
      .then((res) => {
        setSEventList(res.data);
        // check whether unavailable for entire even
        setChecked(checkListForUnavailableAll(res.data));
      })
      .catch((err) => {
        console.log(err);
        if(err.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        history("/somethingwentwrong", {state:`${constants.WFM_GET_EVENT_DETAIL_BY_EVENTID}...failed`})
        }

      });
  };

  
  function AvailabilityCellRender(props) {

    const e = props.eventDay;
      //if isAccomOverlap = y, display 'Accommodation Conflict' non-editable
      if(e.isAccomOverlap && e.isAccomOverlap.toUpperCase() == "Y"){
        // set if any day accom crosses
        setAccomCrossover(true);  
        // return 
          return <TableCell sx={{
            borderTopWidth: "thin",
            borderBottomWidth: "thin",
            borderBottomColor: "darkgray",}}>
              <div style={{display: 'flex', gap: '10px',alignItems: 'center'}}>
                <WarningIcon/>Accommodation Conflict
              </div>
              </TableCell>
         }

    //  if responseId  is null show Select your Availability
    if(e.responseId == null){
      
      return  <TableCell sx={{
                  borderTopWidth: "thin",
                  borderBottomWidth: "thin",
                  borderBottomColor: "darkgray",}}>
                <><div style={{'cursor': "pointer"}} onClick={event => selectAvailability(e)}><u>
               Select Your Availability</u></div></>
              </TableCell>}
    //  if responseAvail  is 'n' show Unavailable for this day
     if(!isEmpty(e.responseAvail) && e.responseAvail.toUpperCase() == "N"){
     
        // return 
        return <TableCell
                  sx={{
                  borderTopWidth: "thin",
                  borderBottomWidth: "thin",
                  borderBottomColor: "darkgray",}}><>Unavailable for this day</>
                  </TableCell>
     }  
     //  if responseAvail  is 'y' show available schedule time with overnight shift applicable
     if(!isEmpty(e.responseAvail) && e.responseAvail.toUpperCase() == "Y"){
      
       return <TableCell
        sx={{
                  borderTopWidth: "thin",
                  borderBottomWidth: "thin",
                  borderBottomColor: "darkgray",
                  padding:isMobile?"24px 4px 24px 10px":"24px 16px"
                 
              }}>
          <span translate="no">{!isEmpty(e.responseIsOvernight1) && e.responseIsOvernight1.toUpperCase() == "Y" && 
          (splitTimeFromDateTime(e.responseStartTime1).time + " - " + splitTimeFromDateTime(e.responseEndTime1).time + " (Overnight Shift)")}
          {!isEmpty(e.responseIsOvernight1) && e.responseIsOvernight1.toUpperCase() != "Y" &&
           (splitTimeFromDateTime(e.responseStartTime1).time + " - " + splitTimeFromDateTime(e.responseEndTime1).time)}
          <br />
          {!isEmpty(e.responseStartTime2) && !isEmpty(e.responseIsOvernight2) && e.responseIsOvernight2.toUpperCase() == "Y" &&
           ((splitTimeFromDateTime(e.responseStartTime2).time + " - " + splitTimeFromDateTime(e.responseEndTime2).time + " (Overnight Shift)"))}
          {!isEmpty(e.responseStartTime2) && !isEmpty(e.responseIsOvernight2) && e.responseIsOvernight2.toUpperCase() != "Y" &&
           ((splitTimeFromDateTime(e.responseStartTime2).time + " - " + splitTimeFromDateTime(e.responseEndTime2).time))}
        </span>
        </TableCell>
       
       }  
        

     return <TableCell></TableCell>
    }

   function PencilIcon(props){
    let e = props.eventDay;

    if(e.isAccomOverlap.toUpperCase() == "Y"){
      
      return <TableCell 
      sx={{
        borderTopWidth: "thin",
        borderBottomWidth: "thin",
        borderBottomColor: "darkgray",
        }} 
       >
      </TableCell>
    }
    if(e.responseId != null){
     
     return <TableCell 
     sx={{
      borderTopWidth: "thin",
      borderBottomWidth: "thin",
      borderBottomColor: "darkgray",
      }}
      onClick={event => handleCellClick(e)} >
       <div style={{'cursor': "pointer"}}><EditOutlinedIcon /></div>
     </TableCell>
    }
    
    return <TableCell 
    sx={{
      borderTopWidth: "thin",
      borderBottomWidth: "thin",
      borderBottomColor: "darkgray",}} 
     >
    </TableCell>

    
    //  {/* check if isAccomOverlap = y hide TableCell for Pencil icon */}
    //  {( e.responseId != null && e.isAccomOverlap.toUpperCase() !== "Y") &&
    //  <TableCell size="small" onClick={event => handleCellClick(e)} >
    //   <EditOutlinedIcon /> 
    //  </TableCell>}
   } 
  const isAccomTypeOFF = (e) => {
    let isAccomOff = false;
    if(!isEmpty(e.svcAccom_hasAccomDay1) && e.svcAccom_hasAccomDay1 == 1 ){
      isAccomOff = e.svcAccom_accomTypeDay1.toUpperCase() == "OFF";
    }
    return isAccomOff;
  }
  const handleAlertNotifClose = () => {
      setAlertOpen({});
    };

 

  const popupUnavailableClose = () => {
      setunavailableDialog(false);
      // reset whether unavailable for entire event
      setChecked(checkListForUnavailableAll(sEventList));
  }

  const popupUnavailableSave = () => {

    setResetUnavailabilityService();
    
  }

  const handleAPiResponse = (severity) =>{
    // TODO: keep the code here for reuse
    setunavailableDialog(false);
    // refresh the event detail APi now
    getEventDetailByEvId(eventId);
    // show alert notification
    setAlertOpen({
      open: true,
      severity: severity,
      message : alertGeneraliseMessage(severity),
    })
  }

  const setResetUnavailabilityService = () =>{
    if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
      setAlertOpen({
        open: true,
        severity: 'error',
        message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
            })
      return;
    }
    let data = {
        eventId: eventId,
        ascNbr: personDetails.emplID,
        // locNbr: personDetails.mystore,
        // divNbr: personDetails.mydiv,
        locNbr: personODSFuture.mystore,
        divNbr: personODSFuture.mydiv,
        deleteOrInsert: iOrD,    
        lastUpdatedBy: personDetails.emplID,
        impersonatedBy: personDetails.impersonate_admin_id,
        languageCode: languageDetails.selected !== '' ? languageDetails.selected : 'en'
    }
    console.log("1-" + iOrD + "2--");
    let divUrl = `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPDATE_RESET_EVENT_UNAVAILABLE_BY_ASC_NBR_EVENT_ID}`
        return  axios({
            url: divUrl,
            method: "POST", 
            data: data, 
            headers : {
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' + colleagueTKN,
            }, })
            .then((response) => {  
                // success close popup
               // props.popupClose();
               // props.popupSave("success");  
               popupUnavailableClose();   
               handleAPiResponse("success");        
        })
        .catch((error) => {
            //catch
            //props.popupClose();
            //props.popupSave("error");
            popupUnavailableClose();
            handleAPiResponse("error");        

        });
}

  const checkListForUnavailableAll = (eventList) => {
    let eventUnavailableStatus = false;
    if(eventList)
    eventUnavailableStatus =  Object.values(eventList).every(val => val.responseAvail == 'n' || val.responseAvail == 'N' );
    return eventUnavailableStatus;
  }

  return (
    <>
    <div className="main_body_special_details">
    <div className = "all_except_button_needs_padding">
      <div className={classes.page_title_wrap}>
        <div className={classes.page_title}>
          <h1 className={classes.h1} style={{fontWeight:"bold"}}>{evenName}</h1>
        </div>
        
        {<div  className={classes.adjustLinks} style={!isMobile ? {justifyContent:"left"}:{marginTop:"-10%",justifyContent:"left"}}>{!isMobile && <TimeOffPTOLinkComp2 isMobile = {isMobile} type={ComponentType.SEA}/> }</div>}
       
        {/*<div className={classes.page_quicklinks_wrap}>
          <a href={ptoLink}>
          <div className={classes.page_quicklink}>
            <CalendarMonthOutlinedIcon />
            <p>Time Off (MTO)</p>
          </div>
          </a>
          <a href={ptoQuickRefLink} target="_blank">
          <div className={classes.page_quicklink}>
            <InsertDriveFileOutlinedIcon />
            <p>Quick Reference Card</p>
            </div>
          </a>
        </div>*/}
      </div>
      
      <div className={classes.adjustLinks}>{isMobile && <TimeOffPTOLinkComp2 type={ComponentType.SEA}/> }</div>
      
      <div>
        <h3 className={classes.h3}>Select your availability for this event </h3>
        <div className={classes.info}>
          <InfoOutlinedIcon />
          <p>These selections are your preferences and are not guaranteed</p>
        </div>
         {showUnavailable && <div className={classes.eventToggle}>
          <p>I am unavailable for this event</p>
          <Switch 
            checked={checked}
            onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
            color={"black"}
          />
        </div>}

        {accomCrossover && (
        <NotificationView
          message={"For accommodation conflicts, please contact your people leader if available for this event."}
          severity="warning"
        />
      )}
      </div>
      <div>

        <Table variant="lined" sx={{ maxWidth: 700 }}>
          <TableHead>
            <TableRow>
              <TableCell
              sx={{
              borderBottomWidth: "thin",
              borderBottomColor: "darkgray"
              }}>
              Date And Time
              </TableCell>
              <TableCell
                sx={{
              borderBottomWidth: "thin",
              borderBottomColor: "darkgray"
              }}
              >
              Availability
              </TableCell>
              <TableCell sx={{
                  borderBottomWidth: "thin",
                  borderBottomColor: "darkgray",
                  }} size="small"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sEventList.length > 0 && sEventList.map((e) => (
              <TableRow
              sx={{
                "&:nth-of-type(even)":{backgroundColor:"whitesmoke"}
              }}>
                <TableCell 
                sx={{
                  borderTopWidth: "thin",
                  borderBottomWidth: "thin",
                  borderBottomColor: "darkgray",
              }}> {e.dayName + ", " + e.dayShort}
                  <br />
                  {/* TODO: flag for overnight Event need to be set */}
                  <span translate="no">
                  {(!isEmpty(e.isOvernightEvent) && e.isOvernightEvent.toUpperCase() == "Y") ? e.dayHoursStart + " - " + e.dayHoursEnd+ " (Overnight Event)" : e.dayHoursStart + " - " + e.dayHoursEnd }
                  </span> 
                </TableCell>
                <AvailabilityCellRender eventDay={e}>
                </AvailabilityCellRender>
               {/* pencil icon */}
               <PencilIcon eventDay={e}></PencilIcon>
              </TableRow>
            ))}

          </TableBody>
        </Table>
        
      </div>
      <div>
      { showPopup && 
        <SpecialEventsDetailPopup 
        eventdata={popupdata} popupClose={popupClose} 
        onSaveSuccess={onUpdateAvailabilitySuccess} />
      }
       {
        unavailableDialog &&
          <UnavailableEventPopup
            title={unavialableDialogText.title}
            message={unavialableDialogText.message}
            popupClose={popupUnavailableClose}
            eventId={eventId}
            popupSave={popupUnavailableSave}
            insertOrDelete={iOrD}
          />
        }
        
      </div>
      </div> {/*this is the div to split the button off from the rest of the code for padding*/}
      <div className={classes.btn}>
        {!isMobile&&
          <Button
          color="secondary"
          className="btnsec"
          onClick={() => history(-1)}
        >
          <KeyboardBackspaceOutlinedIcon/>
          &nbsp; Back To Special Events
        </Button>
        }</div>
        <Box sx={{marginTop:"35%", borderTop: '1px solid grey', minWidth:"100%"}}>
        <div className={classes.btn2}>
        {isMobile&&
          <Button
          color="secondary"
          className="btnsec"
          sx={{ marginRight: "15%",marginTop:"25px",left:"19%" }}
          onClick={() => history(-1)}
        >
          <KeyboardBackspaceOutlinedIcon />
          &nbsp; Back To Special Events
        </Button>
        } </div>
        </Box>
      
    </div>
    <div>
    <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
    </div>
    </>
  );
};

export default SpecialEventsDetail;
